import {
    MDBModal,
    MDBModalBody,
    MDBModalFooter,
    MDBModalHeader,
} from 'mdbreact'
import React, { useEffect, useState } from 'react'
import { getPlayerApi } from '../../../../api/api_football'
import { firestore } from '../../../../firebase'
import ImagePickerReturnUrl from '../../../Admin/Media/templates/ImagePickerReturnUrl'
import SearchTeams from '../../FootballAPI/Search/SearchTeams'

function EditUtenlandsProff({ player }) {
    const [playerApi, setPlayerApi] = useState(player?.api_data)

    const [imageUrl, setImageUrl] = useState('')
    const [name, setName] = useState(player.player_name)
    const [clubName, setClubName] = useState(
        player?.team_name || player.api_data?.team_name
    )

    const [teamId, setTeamId] = useState(player?.team_id)
    const [teamLogo, setTeamLogo] = useState(player?.team_logo)

    const [team, setTeam] = useState()

    const [show, setShow] = useState(false)
    const [showSearch, setShowSearch] = useState(false)

    const [message, setMessage] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        async function getPlayerApiData() {
            if (player?.player_id) {
                const playerApiData = await getPlayerApi(player?.player_id)
                if (playerApiData?.length > 0) {
                    setPlayerApi(playerApiData[0])
                    console.log(playerApiData[0], 'playerAapidata')
                }
            }
        }
        getPlayerApiData()
    }, [player])

    async function editPlayerHandler(e) {
        e.preventDefault()
        const data = {
            api_data: playerApi,
            player_name: name,
            player_image: imageUrl,
            team_name: clubName,
            team_id: teamId,
        }
        console.log(data)
        try {
            const proffRef = firestore
                .collection('utenlandsproffer')
                .doc(player.id)

            proffRef.update(data)
            console.log('Oppdatert', data)
            setMessage('Oppdatert')
        } catch (error) {
            setError('Kunne ikke oppdatere')
        }
    }

    useEffect(() => {
        if (team) {
            setClubName(team?.name)
            setTeamId(team?.team_id)
            setTeamLogo(team?.logo)
        }
    }, [team])

    function toggleSearch() {
        if (showSearch) {
            setShowSearch(false)
        } else {
            setShowSearch(true)
        }
    }

    return (
        <React.Fragment>
            <form onSubmit={editPlayerHandler}>
                <label>Navn</label>
                <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="form-control mb-2"
                />

                <label>Klubb</label>
                <input
                    value={clubName}
                    onChange={(e) => setClubName(e.target.value)}
                    className="form-control mb-2"
                />

                <p>
                    <label>Bilde</label>
                </p>
                {imageUrl && (
                    <img
                        style={{ maxWidth: '500px' }}
                        src={imageUrl}
                        className="img-fluid"
                        alt=""
                    />
                )}
                <div
                    className="btn btn-success btn-block"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShow(true)}
                >
                    Velg bilde url
                </div>

                <div className="my-5">
                    <div
                        className="btn btn-danger btn-block"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setShowSearch(true)}
                    >
                        Rediger lag
                    </div>
                </div>
                <hr />

                {error && (
                    <div
                        onClick={() => setError('')}
                        className="alert alert-danger"
                    >
                        {error}
                    </div>
                )}
                {message && (
                    <div
                        onClick={() => setMessage('')}
                        className="alert alert-success"
                    >
                        {message}
                    </div>
                )}
                <button className="btn btn-block btn-primary">Lagre</button>
            </form>
            <ImagePickerReturnUrl
                show={show}
                setShow={setShow}
                imageUrl={imageUrl}
                setImageUrl={setImageUrl}
            />
            <MDBModal size="fluid" isOpen={showSearch} toggle={toggleSearch}>
                <MDBModalHeader toggle={toggleSearch}>Søk lag</MDBModalHeader>
                <MDBModalBody>
                    <SearchTeams
                        selectedTeam={team}
                        setSelectedTeam={setTeam}
                        type="teamSelector"
                        teamName={clubName}
                    />
                </MDBModalBody>
                <MDBModalFooter>
                    <button onClick={() => setShowSearch(false)}>Lukk</button>
                </MDBModalFooter>
            </MDBModal>
        </React.Fragment>
    )
}
export default EditUtenlandsProff
